import { DEFAULT_USER_DATA } from "@/constants/defaults"
import type { TLoginUserData } from "@/schemas/user.schema"
import { observable } from "@legendapp/state"
import { synced } from "@legendapp/state/sync"
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage"

interface TWebphoneDetachedPosition {
  x: number
  y: number
  width: number
  height: number
  screenX: number
  screenY: number
}

interface AppData {
  isTrialBannerHidden: boolean
  isSidebarMenuExpanded: boolean
  userData: TLoginUserData
  _old_webphone: boolean
  webphoneSelectedContactID?: string
  webphoneExpanded: boolean
  webphonePoppedOut: boolean
  webphonePopup: {
    height: number
    width: number
  }
  webphoneDetached: boolean
  webphoneDetachedPosition: TWebphoneDetachedPosition
}

const DEFAULT_DETACHED_POSITION: TWebphoneDetachedPosition = {
  x: 100,
  y: 100,
  width: 420,
  height: 700,
  screenX: 100,
  screenY: 100,
}

const initialState: AppData = {
  isSidebarMenuExpanded: false,
  isTrialBannerHidden: false,
  userData: {
    ...DEFAULT_USER_DATA,
  },
  _old_webphone: false,
  // @deprecated The embedded frontend webphone is disabled. The Chrome extension now provides the webphone sidebar.
  webphoneExpanded: false,
  webphonePoppedOut: false,
  webphonePopup: {
    height: 600,
    width: 420,
  },
  webphoneDetached: false,
  webphoneDetachedPosition: DEFAULT_DETACHED_POSITION,
}

interface AppStore extends AppData {
  //   changeSidebarMenuState: (setExpanded: boolean) => void
  //   setUserData: (userData: TLoginUserData) => void
  //   setWebphoneExpanded: (expanded: boolean) => void
  //   setWebphonePoppedOut: (poppedOut: boolean) => void
  //   setWebphonePopupSize: ({ width, height }: { width: number; height: number }) => void
  //   changeWebphonePopupOld: (old: boolean) => void
  //   changeSelectedContactID: (contactID?: string) => void
}

export const appStore$ = observable<AppStore>({
  ...initialState,
})

// Separate persisted observable for setup checklist confetti state
export const setupChecklistConfettiShown$ = observable(
  synced({
    initial: false,
    persist: {
      name: "setupChecklistConfettiShown",
      plugin: ObservablePersistLocalStorage,
    },
  })
)
